<template>
  <div>
    <template v-if="isSeoServiceConnected">
      <sos />
      <access />
      <call-order />
      <!-- deprecated -->
      <c-modal-form
        id="select-client"
        title="Выбор клиента"
        :submit-btn="false"
      >
        <form>
          <c-input
            v-model="selectedClientId"
            title="client_id"
            form-group
          />
          <c-select
            v-model="selectedClientId"
            title="client"
            :options="$store.state.seo.projects.projects"
            form-group
            @update:selected="hideModal('select-client')"
          />
        </form>
      </c-modal-form>
      <mail-order />
      <quality-service />
      <interview />
      <documents-order />
      <privilege-order />
      <service-order />
      <no-money />
      <agreements-exists />
      <good-news />
    </template>
  </div>
</template>

<script>
import CModalForm from '../ui/CModalForm'
import CSelect from '../ui/CSelect'
import CInput from '../ui/CInput'
import CallOrder from '../../../../Modules/Seo/Resources/assets/js/components/modals/CallOrder'
import modal from '../../mixins/modal'
import Access from '../../../../Modules/Seo/Resources/assets/js/components/modals/Access'
import Sos from '../../../../Modules/Seo/Resources/assets/js/components/modals/Sos'
import MailOrder from '../../../../Modules/Seo/Resources/assets/js/components/modals/MailOrder'
import QualityService from '../../../../Modules/Seo/Resources/assets/js/components/modals/QualityService'
import Interview from '../../../../Modules/Seo/Resources/assets/js/components/modals/Interview'
import DocumentsOrder from '../../../../Modules/Seo/Resources/assets/js/components/modals/DocumentsOrder'
import PrivilegeOrder from '../../../../Modules/Seo/Resources/assets/js/components/modals/PrivilegeOrder'
import { mapActions, mapGetters } from 'vuex'
import ServiceOrder from '../../../../Modules/Seo/Resources/assets/js/components/modals/ServiceOrder'
import NoMoney from '../../../../Modules/Seo/Resources/assets/js/components/modals/NoMoney'
import AgreementsExists from '../../../../Modules/Seo/Resources/assets/js/components/modals/AgreementsExists'
import GoodNews from '../../../../Modules/Seo/Resources/assets/js/components/modals/GoodNews'

/**
 * Модальные окна.
 *
 * Все модальные окна не должны быть вложены в .content-wrapper в связи с проблемами в отображении
 * контента (когда, например, на мобильной версии развернут sidebar, содержимое модального окна сдвинуто вправо),
 * по этому модальные окна обеднены вместе в один компонент.
 */
export default {
  name: 'TheModals',
  components: {
    AgreementsExists,
    NoMoney,
    ServiceOrder,
    CModalForm,
    CSelect,
    CInput,
    CallOrder,
    Access,
    Sos,
    MailOrder,
    QualityService,
    Interview,
    DocumentsOrder,
    PrivilegeOrder,
    GoodNews
  },
  mixins: [modal],
  computed: {
    /**
     * Выбранный id клиента, от которого осуществляется просмотр содержимого.
     *
     * @deprecated
     */
    selectedClientId: {
      get () {
        return this.$store.state.seo.projects.selectedClientId
      },
      set (value) {
        this.changeSelectedClientId(value)
      }
    },
    isSeoServiceConnected () {
      return this.isServiceConnected(this.$getConst('SERVICE_SEO'))
    },
    ...mapGetters({
      isServiceConnected: 'services/isConnected'
    })
  },
  methods: {
    ...mapActions({
      // deprecated
      changeSelectedClientId: 'seo/projects/changeSelectedClientId'
    })
  }
}
</script>
